module.exports = __webpack_public_path__ + "img/214.problem_broken_toilet_handle.267b7d8d.svg";